import { toggle } from '@utils';

export function toggleCondidentielExplanation() {
  toggle(document.querySelector('.confidentiel-explanation'));
}
